// extracted by mini-css-extract-plugin
export var box = "Slider-module--box--c5b2f";
export var box_md = "Slider-module--box_md--9ed52";
export var box_xmd = "Slider-module--box_xmd--e46d0";
export var box_flex = "Slider-module--box_flex--169ee";
export var box_lg = "Slider-module--box_lg--76ed2";
export var box_sm = "Slider-module--box_sm--7f252";
export var box_outer = "Slider-module--box_outer--9d769";
export var box_whiteBg = "Slider-module--box_white-bg--a2a21";
export var box_noMarginBottom = "Slider-module--box_no-margin-bottom--2082f";
export var box_noPadding = "Slider-module--box_no-padding--73460";
export var box_outerGray = "Slider-module--box_outer-gray--ac7a8";
export var box_dark = "Slider-module--box_dark--dfe6b";
export var box_zIndex = "Slider-module--box_z-index--505b5";
export var box_zIndex6 = "Slider-module--box_z-index-6--fbc1f";
export var box_eventsWithLine = "Slider-module--box_events-with-line--56a52";
export var box_featuresAo = "Slider-module--box_features-ao--d99c3";
export var box_verticalPaddings = "Slider-module--box_vertical-paddings--c6f6e";
export var clearP = "Slider-module--clearP--daf7f";
export var clearP_vc = "Slider-module--clearP_vc--9e380";
export var controls = "Slider-module--controls--490eb";
export var fadeInAnimation = "Slider-module--fadeInAnimation--34932";
export var placeHolderShimmer = "Slider-module--placeHolderShimmer--0cd66";